import {
  handleNetworkError,
  handleSuccessToast,
} from "@/Components/Uitoast/globalToastHandler";
import { handleGlobalPostRequest } from "@/lib/httpFunction/globalApiFunction";
import { useSingleUserService } from "@/services/hooks/users/useUserServices";
import { CORE_URLS } from "@/services/URLS/CORE_URLS";
import { useMutation } from "@tanstack/react-query";

const useAuthCard = () => {
  const {
    services: { getSingleUserService },
  } = useSingleUserService();

  const logOutMutations = useMutation({
    mutationFn: () => handleGlobalPostRequest({ url: CORE_URLS.LOGOUT }),
    onError: (error) => {
      handleNetworkError({ error });
    },
  });

  const handleLogOut = () => {
    logOutMutations.mutateAsync().then(() => {
      localStorage.clear();
      window.location.reload();
      handleSuccessToast({ message: "Logout Successfully" });
    });
  };

  return {
    services: {
      getSingleUserService,
    },
    mutations: { logOutMutations },
    function: { handleLogOut },
  };
};

export default useAuthCard;
